import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.apl = bracketIndenting({ line: "⍝" })
